(() => {
  const config = window.girlBackground;

  if (!config || !Array.isArray(config.candidates)) {
    return;
  }

  const loadImage = (url) =>
    new Promise((resolve) => {
      const image = new Image();

      image.onload = () => resolve(url);
      image.onerror = () => resolve(null);
      image.src = url;
    });

  Promise.all(config.candidates.map(loadImage)).then((results) => {
    const availableImages = results.filter(Boolean);

    if (!availableImages.length) {
      return;
    }

    const selectedImage = availableImages[Math.floor(Math.random() * availableImages.length)];

    document.body.style.setProperty('--girl-background-image', `url("${selectedImage}")`);
  });

  let ticking = false;

  const updateGirlOffset = () => {
    const offset = Math.min(window.scrollY * 0.28, 260);
    document.body.style.setProperty('--girl-background-offset', `${offset}px`);
    ticking = false;
  };

  updateGirlOffset();

  window.addEventListener(
    'scroll',
    () => {
      if (ticking) {
        return;
      }

      ticking = true;
      window.requestAnimationFrame(updateGirlOffset);
    },
    { passive: true }
  );
})();
